import { render, staticRenderFns } from "./dialogGroup.vue?vue&type=template&id=8b5b19ee&scoped=true"
import script from "./dialogGroup.vue?vue&type=script&lang=js"
export * from "./dialogGroup.vue?vue&type=script&lang=js"
import style0 from "./dialogGroup.vue?vue&type=style&index=0&id=8b5b19ee&prod&lang=less&scoped=true"
import style1 from "./dialogGroup.vue?vue&type=style&index=1&id=8b5b19ee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5b19ee",
  null
  
)

export default component.exports